import * as React from "react";
const SvgFiRrLaptopArrowDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 15.172V8c0-2.757-2.243-5-5-5h-1a1 1 0 1 0 0 2h1c1.654 0 3 1.346 3 3v7h-4.5a1 1 0 0 0-.707.293l-.707.707H9.914l-.707-.707A1 1 0 0 0 8.5 15H4V8c0-1.654 1.346-3 3-3h1a1 1 0 0 0 0-2H7C4.243 3 2 5.243 2 8v7.172A3 3 0 0 0 0 18c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3a3 3 0 0 0-2-2.828M21 19H3a1.001 1.001 0 0 1 0-2h5.086l.707.707A1 1 0 0 0 9.5 18h5c.266 0 .52-.105.707-.293l.707-.707H21a1 1 0 0 1 0 2M11 9.42V1a1 1 0 0 1 2 0v8.421l2.319-2.154a1 1 0 1 1 1.361 1.466l-2.613 2.426a2.9 2.9 0 0 1-2.058.843 2.97 2.97 0 0 1-2.103-.869l-2.587-2.4a1 1 0 1 1 1.36-1.466z"
    />
  </svg>
);
export default SvgFiRrLaptopArrowDown;
